const mediaCache = new Map();
const fetchCache = new Map();
const MAX_CACHE_SIZE = 100;

function clearCaches() {
  for (const url of mediaCache.values()) {
    if (url.value) {
      URL.revokeObjectURL(url.value);
      continue;
    }

    URL.revokeObjectURL(url);
  }
  mediaCache.clear();
  fetchCache.clear();
}

function setInCache(cache, key, value) {
  if (cache.size >= MAX_CACHE_SIZE) {
    const firstKey = cache.keys().next().value;
    const url = mediaCache.get(firstKey);
    if (url) URL.revokeObjectURL(url);
    cache.delete(firstKey);
  }
  cache.set(key, value);
}

function setInCacheWithMetadata(cache, key, value, metadata = {}) {
  if (cache.size >= MAX_CACHE_SIZE) {
    const firstKey = cache.keys().next().value;
    const url = mediaCache.get(firstKey);
    if (url) URL.revokeObjectURL(url);
    cache.delete(firstKey);
  }
  cache.set(key, { value, ...metadata });
}

export { clearCaches, setInCache, mediaCache, fetchCache, setInCacheWithMetadata };
